import {
    FACEBOOK_UNREGISTERED_USER,
    GOOGLE_UNREGISTERED_USER, SIGNUP_DATA
} from '../actions/Types';
const INITIAL_STATE = {
    signupData: {}    
    
}
export default (state = INITIAL_STATE, action) =>
{    
    switch(action.type)
    {
        case SIGNUP_DATA:
            return {...state, signupData: action.payload};

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/AuthReducer.js